import { render, staticRenderFns } from "./paid.vue?vue&type=template&id=bb65556a&scoped=true&"
import script from "./paid.vue?vue&type=script&lang=js&"
export * from "./paid.vue?vue&type=script&lang=js&"
import style0 from "./paid.vue?vue&type=style&index=0&id=bb65556a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb65556a",
  null
  
)

export default component.exports